import { render, staticRenderFns } from "./ModelEdit.vue?vue&type=template&id=682db7c0&scoped=true"
import script from "./ModelEdit.vue?vue&type=script&lang=js"
export * from "./ModelEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "682db7c0",
  null
  
)

export default component.exports